import { api } from 'agent';
import { InspectionDTO } from './dtos/InspectionDTO';

export default function getInspectionById(inspectionId: number): Promise<InspectionDTO> {
  return api
    .get(`inspection/${inspectionId}`)
    .then((response: { data: InspectionDTO }) => response.data);
}
